import { parseOptions } from '@/router'
import qs from 'query-string'
import { filter } from 'remeda'
import type { LocationQuery } from 'vue-router'

export function decodeFragmentEntry(
    entry: string | number
): number | string | string[] {
    if (typeof entry === 'number') {
        return entry
    }

    if (entry.includes(',')) {
        return entry.split(',')
    }

    return entry
}

export type FragmentValue = string | number | (string | number)[] | undefined

export function encodeFragmentEntry(entry: FragmentValue): string {
    if (Array.isArray(entry)) {
        return entry.join(',')
    }

    return String(entry)
}

const filterEmtpyFragments = (fragments: [string, FragmentValue][]) =>
    filter(fragments, (fragment) => Boolean(fragment[1])) as [
        string,
        NonNullable<FragmentValue>,
    ][]

export function encodeFragments(
    fragments: Record<string, FragmentValue>
): string {
    return filterEmtpyFragments(Object.entries(fragments))
        .map((fragment) => `${fragment[0]}=${encodeFragmentEntry(fragment[1])}`)
        .join('&')
}

export function getFragmentFromHash(hash: string): Record<string, string> {
    return Object.fromEntries(
        Object.entries(
            qs.parse(hash.substring(1), parseOptions) as LocationQuery
        )
            .map((v) => {
                if (Array.isArray(v[1])) {
                    return v
                }

                if (null === v[1]) {
                    return v
                }

                return [v[0], decodeFragmentEntry(v[1])]
            })
            .filter((v) => !!v[1])
    )
}
